<template>
  <div class="row">
    <!-- <div class="col-lg-12"> -->
    <card type="tasks" style="height:700px;">
      <template slot="header">
        <div class="row">
          <!-- <button @click="toggleAutoScroll">Toggle Auto Scroll</button> -->
          <h4 class="card-title" style="margin-left: 18px">
            <i class="tim-icons icon-bell-55 text-primary"></i>
            控制台
          </h4>
          <div class="ml-auto">
            <div>
              <base-button
                style="margin-right: 10px"
                size="sm"
                type="info"
                @click="clearScroll"
                >清空控制台</base-button
              >
              <base-button
                style="margin-right: 10px"
                size="sm"
                type="danger"
                @click="breakScroll"
                >断开控制台</base-button
              >
              <base-button
                style="margin-right: 10px"
                size="sm"
                :type="autoScroll ? 'warning' : 'success'"
                @click="toggleAutoScroll"
                >{{ scrollText }}</base-button
              >
            </div>
          </div>
        </div>
      </template>
      <div class="controlbackground">
        <div class="infinite-list scrollable-area" style="padding-right: 44px;" ref="list">
          <ul style="padding-left: 20px">
            <li v-for="message in messages" :key="message.id">
              <div
                class="centered-content"
                v-if="message.websocketType == 'success'"
              >
                <badge type="success" class="font-size: 20px;margin: 0px;"
                  >系统成功消息 {{ getCurrentDateTime() }}</badge
                >
                <span style="margin-left: 15px; color: #00bf9a">{{
                  message.messages
                }}</span>
              </div>

              <div
                class="centered-content"
                v-if="message.websocketType == 'normal'"
                style="max-width: 100%; overflow-wrap: break-word;"
              >
                <div><badge type="warning" class="font-size: 20px;margin: 0px;"
                  >系统通知消息 {{ getCurrentDateTime() }}</badge
                ></div>

                <div style="margin-left: 15px;max-width: 100%;" class="breakable-content">{{ message.messages }}</div>

              </div>

              <div
                class="centered-content"
                v-if="message.websocketType == 'error'"
                style="max-width: 100%; overflow-wrap: break-word;"
              >
                <div><badge type="danger" class="font-size: 20px;margin: 0px;"
                  >系统错误消息 {{ getCurrentDateTime() }}</badge
                ></div>
                <div style="margin-left: 15px; max-width: 100%; color: #f5365c" class="breakable-content">{{message.messages}}</div>
              </div>

              <div
                class="centered-content"
                v-if="message.websocketType == 'warn'"
                   style="max-width: 100%; overflow-wrap: break-word;"
              >
                <div><badge type="primary" class="font-size: 20px;margin: 0px;"
                  >系统警告消息 {{ getCurrentDateTime() }}</badge
                ></div>
                <div style="margin-left: 15px; max-width: 100%; color: sandybrown" class="breakable-content" >{{message.messages}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </card>
    <!-- </div> -->
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">网站管理</h4>
            </div>
           
            <div class="ml-auto">
              <div>
                  <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="primary"
                  disabled
                  >宁波换绑剩余账号：{{ningBoBandNum}}个</base-button
                >
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="default"
                  @click="ningBoJingPing"
                  >宁波精品账号换绑</base-button
                >
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="ningBoTongYong"
                  >宁波通用账号换绑</base-button
                >
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <base-table :data="tableData" :columns="columns">
            <template slot="columns">
              <th>id</th>
              <th>网站名称</th>
              <th>网站链接</th>
              <th>网站状态</th>
            </template>
            <template slot-scope="{ row }">
              <td>{{ row.id }}</td>
              <td>{{ row.name }}</td>
              <td>{{ row.link }}</td>
              <td>
                <base-button
                  v-if="row.state == 0"
                  style="margin-left: 6px"
                  size="sm"
                  round
                  icon
                  type="danger"
                  @click="changeSiteState(row.id)"
                  ><i class="tim-icons icon-button-pause"></i
                ></base-button>
                <base-button
                  v-if="row.state == 1"
                  style="margin-left: 6px"
                  size="sm"
                  round
                  icon
                  type="success"
                  @click="changeSiteState(row.id)"
                  ><i class="tim-icons icon-triangle-right-17"></i
                ></base-button>
              </td>
            </template>
          </base-table>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import { http, locations } from "../../util/http.js";
import { Select, Option } from "element-ui";
import Swal from "sweetalert2";
import { InfiniteScroll } from "element-ui";
import Badge from "@/components/Badge";
import { getCurrentDateTime } from "../../util/utils.js";

export default {
  directives: {
    InfiniteScroll, // 在 directives 选项中注册
  },
  components: {
    Badge,
    BaseTable,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      ningBoBandNum: 0,
      messages: [],
      loading: false,
      scrollText: "停止自动滚动",
      autoScroll: true, // 控制自动滚动的标志
      ///////////
      heartBeatInterval: 30000,
      heartbeatTimer: null,
      ws: null,
      siteId: "",
      columns: ["id", "name", "link", "state"],
      tableData: [],
      getCurrentDateTime,
    };
  },
  created() {
    this.connect();
  },
  mounted() {
   this.getHome()
  },
  methods: {
    getHome(){
       http
      .get("/v1/admin/getAllSite", {
        headers: { adminToken: localStorage.getItem("adminToken") },
      })
      .then((res) => {
        if (res.data.code != 200) {
          this.$notify({
            type: "danger",
            message: res.data.message,
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        this.tableData = res.data.data.siteData;
        this.ningBoBandNum = res.data.data.ningBoBandNum;
      })
      .catch((error) => {
        console.error("发生错误:", error);
        // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
      });
    },
    clearScroll() {
      // 清空控制台
      this.messages = [];
    },
    breakScroll() {
      // 断开控制台
      this.ws.close();
    },
    loadMore() {
      // 该方法应该负责加载更多的消息
      // 但在本例中，新消息是由 WebSocket 推送的，所以这里可能不需要做任何事情
    },
    scrollToBottom() {
      if (this.autoScroll) {
        // 仅当 autoScroll 为 true 时执行
        this.$nextTick(() => {
          const list = this.$refs.list;
          if (list) {
            list.scrollTop = list.scrollHeight;
          }
        });
      }
    },
    toggleAutoScroll() {
      if (this.autoScroll) {
        this.scrollText = "开启自动滚动";
      } else {
        this.scrollText = "停止自动滚动";
      }
      this.autoScroll = !this.autoScroll; // 切换 autoScroll 状态
    },
    handleNewMessage(data) {
      this.messages.push(data);
      // 每次接收到新消息时，滚动到底部
      this.scrollToBottom();
    },
    connect() {
      // 假设你的 WebSocket 服务运行在 ws://localhost:8080/websocket
      this.ws = new WebSocket(
        "wss://xue.qdtc5.top/v1/admin/ws?adminToken=" +
          localStorage.getItem("adminToken")
      );
      this.ws.onopen = () => {
        console.log("WebSocket 连接已打开");
        // 在这里可以发送一个初始的消息
        // this.ws.send('你好，服务器！');
        this.startHeartBeat(); //开始心跳检测
      };

      this.ws.onmessage = (event) => {
        // console.log("收到消息:", event.data);
        let resData = JSON.parse(event.data);
        this.handleNewMessage(resData);
        // 这里处理接收到的消息
      };

      this.ws.onerror = (error) => {
        console.error("WebSocket 错误:", error);
        this.stopHeartBeat(); // 停止心跳检测
      };

      this.ws.onclose = (event) => {
        console.log("WebSocket 连接已关闭:", event);
        // 可以在这里处理重连逻辑
        this.stopHeartBeat(); // 停止心跳检测
      };
    },
    startHeartBeat() {
      // 设置定时心跳
      this.heartBeatTimer = setInterval(() => {
        // console.log("正在执行心跳检测");
        if (this.ws.readyState === WebSocket.OPEN) {
          // 发送心跳消息
          this.ws.send("PING");
        }
      }, this.heartBeatInterval);
    },
    stopHeartBeat() {
      // 清除定时心跳
      if (this.heartBeatTimer) {
        clearInterval(this.heartBeatTimer);
        this.heartBeatTimer = null;
      }
    },
    sendMessage(message) {
      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(message);
      } else {
        console.error("WebSocket 连接未打开");
      }
    },
     ningBoJingPing() {//宁波精品换绑
      http
        .get("v1/admin/wangXiaoTongLogin?auth=asd123", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
            this.getHome()
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    ningBoTongYong() {//宁波通用换绑
      http
        .get("v1/admin/wangXiaoTongLoginTongYong?auth=asd123", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
            this.getHome()
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    changeSiteState(id) {
      http
        .post(
          "/v1/admin/updateSite",
          {
            siteId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.tableData = res.data.data;
          Swal.fire({
            icon: "success",
            title: "更改成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close(); // 在组件销毁之前关闭 WebSocket 连接
      // 清除心跳包定时器
      this.stopHeartBeat();
    }
  },
  watch: {
    // 假设有一个数据列表，当它更新时会触发滚动到底部
    yourDataList: {
      handler() {
        this.scrollToBottom();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.modal-content {
  width: 800px;
}

.controlbackground {
  background-color: black;
  border-radius: 5px;
  width: 100%;
  height: 100%;
}
.infinite-list {
  height: 100%;
  overflow-y: auto;
}

li {
  list-style-type: none;
}

/* 滚动区域默认不显示滚动条 */
.scrollable-area {
  overflow: hidden; /* 隐藏滚动条 */
}

/* 滚动区域悬停时显示滚动条 */
.scrollable-area:hover {
  overflow-y: scroll; /* 显示竖直滚动条 */
}

/* 滚动条整体部分 */
.scrollable-area:hover::-webkit-scrollbar {
  width: 12px;
}

/* 滚动条滑块 */
.scrollable-area:hover::-webkit-scrollbar-thumb {
  background-color: white;
  border-radius: 6px;
  border: 3px solid transparent;
  background-clip: content-box;
}

/* 滚动条轨道 */
.scrollable-area:hover::-webkit-scrollbar-track {
  background: rgba(252, 252, 252, 0.2);
  border-radius: 6px;
}

.centered-content {
  /* display: flex; */
  /* align-items: center; */
  color: #fff; /* 移动到这里来应用于所有的 li */
  margin-top: 10px;
  
  display: flex;
  flex-direction: row; /* 确保元素水平排列 */
  align-items: center; /* 元素垂直居中 */
  justify-content: flex-start; /* 从左到右排列 */
  width: 100%; /* 或你的期望宽度 */
}

.badge {
  margin-bottom: 0;
}
.breakable-content {
  white-space: normal; /* 允许根据内容自动换行 */
  overflow-wrap: break-word; /* 确保长单词能够被折行 */
  word-break: break-all; /* 在需要时强制折行 */
}

.badge-primary {
  background-color: sandybrown;
}
</style>



 